import request from '@/utils/request'

const http = request()

export const statDashboard = () => http.post('/stat/dashboard')

export const statProject = range => http.post('/stat/project', { range })

export const statProjectYears = () => http.post('/stat/project/years')

export const statProjectAmountByYear = year => http.post('/stat/project/year', { year })

export const statRaiseYears = () => http.post('/stat/raise/years')

export const statRaiseAmountByYear = year => http.post('/stat/raise/year', { year })

export const statRaiseAmountByMonth = (startDate, endDate) => http.post('/stat/raise/month', { startDate, endDate })

export const statRaiseAmountByRange = (startDate, endDate) => http.post('/stat/raise/range', { startDate, endDate })

export const statRaiseAmountByName = params => http.post('/stat/raise/name', params)

export const statRaiseAmountByDate = (startDate, endDate, capitalPoolId) => http.post('/stat/raise/date', { startDate, endDate, capitalPoolId })

export const statRaiseAmountByBank = params => http.post('/stat/raise/bank', params)
